var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcVisaLogo = function SvgCcVisaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 32,
    viewBox: "0 0 50 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1330.000000, -221.000000) translate(56.000000, 221.000000) translate(1112.000000, 0.000000) translate(162.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 32,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1F71",
    fillRule: "nonzero",
    d: "M22.112 18.643L19.74 7.523h-2.869l2.372 11.12h2.869zm12.07-7.18l1.51 4.176.869-4.176h-2.38zm3.202-3.94h2.653l-2.318 11.12h-2.447c-.552 0-1.016-.32-1.222-.815L29.745 7.524h3.013l.598 1.66h3.68l.348-1.66zm-7.49 3.63c.013 2.935-4.045 3.098-4.018 4.409.009.398.388.823 1.216.931.411.054 1.545.096 2.83-.497l.502 2.359c-.69.25-1.578.491-2.683.491-2.836 0-4.831-1.51-4.847-3.675-.019-1.601 1.425-2.494 2.51-3.027 1.119-.545 1.494-.894 1.488-1.381-.007-.746-.892-1.077-1.715-1.089-1.444-.023-2.28.391-2.947.703l-.52-2.438c.67-.308 1.908-.576 3.189-.59 3.015 0 4.987 1.493 4.995 3.805m-11.881 7.489l-4.649-11.12h-3.032l-2.288 8.875c-.138.545-.26.746-.681.976-.69.376-1.829.728-2.83.946l.067.323h4.882c.622 0 1.182-.415 1.324-1.133l1.208-6.435L15 18.643h3.014z",
    transform: "translate(2.500000, 3.000000) translate(22.284765, 13.097482) scale(1, -1) translate(-22.284765, -13.097482)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B600",
    fillRule: "nonzero",
    d: "M0 26L45 26 45 21.955 0 21.955z",
    transform: "translate(2.500000, 3.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1F71",
    fillRule: "nonzero",
    d: "M0 0L45 0 45 4.045 0 4.045z",
    transform: "translate(2.500000, 3.000000)"
  })))))))));
};
export default SvgCcVisaLogo;